import { Grid, Typography } from "@material-ui/core";
import '../TitleAndData/customstyles.css'
import ButtonBase from '@material-ui/core/ButtonBase';
import React from "react";
import { useStyles } from "./styles";
import parse from "html-react-parser";
import { backgrounds } from "polished";
import EXPOImg from '../../assets/08.png';
import second from '../../assets/09.png';
import three from '../../assets/10.png';
import four from '../../assets/11.png';
import five from '../../assets/12.png';
import six from '../../assets/13.png';
import seven from '../../assets/14.png';
import eight from '../../assets/15.png';
import nine from '../../assets/16.png';
import whatsapp from '../../assets/WhatsApp Button.png';
import direction from '../../assets/get-direction.png';
const { pathname } = window.location;


const TitleAndData = (props) => {
  
  let path = pathname.toLowerCase();  
  const classes = useStyles();
  const { title, description, richEditor } = props;
  function openNewWindow(url) {
    window.open(url, '_blank');
  }  
  const data =[
    {img1:EXPOImg, img2:direction,wlink:"",geolocation:"https://maps.app.goo.gl/fbpsDZPyXYYegeYh9"},
    {img1:second, img2:direction,wlink:"",geolocation:"https://maps.app.goo.gl/QPzMqJ6dbFHtJQXb8"},
    {img1:three, img2:direction,wlink:"",geolocation:"https://maps.app.goo.gl/QPzMqJ6dbFHtJQXb8"},
    {img1:four, img2:direction,wlink:"",geolocation:"https://maps.app.goo.gl/hbxhiwSLEXGzR7n9A"},
    {img1:five, img2:direction,wlink:"",geolocation:"https://maps.app.goo.gl/o98zaafvnExtMPLJ7"},
    {img1:six, img2:direction,wlink:"",geolocation:"https://maps.app.goo.gl/8XRQEH5LnLBzH6h38"},
    
    {img1:seven, img2:direction,wlink:"",geolocation:"https://maps.app.goo.gl/RVuwrHGewT3Fyuih7"},
    {img1:eight, img2:direction,wlink:"",geolocation:"https://maps.app.goo.gl/73iA41T8pC5qQ1MMA"},
   
  ]
  return (
    < >
      <Grid lg={12} xs={12} className={classes.roots} >
      <div className={classes.headerAlign}>
          <img alt="images" loading="lazy" className={classes.logoEdits} src="https://s3-ap-southeast-1.amazonaws.com/media.nacjewellers.com/resources/static+page+images/collection+page/urn_aaid_sc_US_4f2880c9-1910-41e4-b332-90c4513a4ca7+(1).png" />
          <Typography className={classes.headings}>{title}</Typography>
          
          <img alt="images" loading="lazy" className={classes.logoEdits} src="https://s3-ap-southeast-1.amazonaws.com/media.nacjewellers.com/resources/static+page+images/collection+page/urn_aaid_sc_US_4f2880c9-1910-41e4-b332-90c4513a4ca7+(2).png" />
        </div>
        <div className={classes.richTextEditAlign}>{parse(richEditor)}</div>
      </Grid>
      
       
        {path === '/usa+expo' ? (
          <>
          <div style={{ padding:'30px 30px 0px 30px', width:'100%', backgroundColor:"#f0e8d5", display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Grid  container spacing={2} xs={12} lg={8}  >
          {data.map((data, index) =>(
           
            <Grid item xs={6} sm={6} md={6} lg={6}  style={{display:'flex', justifyContent:'center',cursor: 'pointer', alignItems:"center"}} key={index}>
            <div className="custom_size" style={{position:"relative", display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
            <img style={{ width: '100%', height: 'auto' }} src={data.img1} alt="USA_Expo" onClick={() => openNewWindow(data.geolocation)}/>
            
            </div>
            </Grid>
          ))}
          </Grid>
        
         
   
    
  </div>
  <div style={{  padding:'0px 30px 40px 30px', width:'100%', backgroundColor:"#f0e8d5", display:'flex', justifyContent:'center', alignItems:'flex-start'}}>
    
          <Grid  container spacing={2} xs={12} lg={8} style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'flex-start'}} >
         
  <Grid item xs={6} sm={6} lg={6} style={{display:'flex', justifyContent:'center', alignItems:"center"}} >
  <div className="custom_size" style={{position:"relative", display:'flex', cursor: 'pointer', flexDirection:'column', justifyContent:'flex-start', alignItems:'center'}}>
  <img className="parent-img" style={{ width: '100%', height: 'auto' }} src={nine} alt="USA_Expo" onClick={() => openNewWindow('https://maps.app.goo.gl/Qz9DQenTUuHeQPrA6')}/>
  {/* <img className="cus_cs last" style={{ width: '50%', height: 'auto',position:"absolute",bottom:'-25px'  }} src={direction} alt="USA_Expo" onClick={() => openNewWindow('https://maps.app.goo.gl/ktJYZPTB4gBfd2TF9')}/> */}
  {/* <img className="cus_cs last" style={{ width: '50%', height: 'auto',position:"absolute",bottom:'-25px'  }} src={direction} alt="USA_Expo" onClick={() => openNewWindow('https://maps.app.goo.gl/Qz9DQenTUuHeQPrA6')}/> */}
  </div>
  </Grid>
          
          </Grid>
        
    
  </div>
  <div style={{width:'100%', display:"flex", justifyContent:'center', alignItems:'center' , padding:'20px 5px '}}>
          <Grid  container spacing={1} justifyContent="center" lg={8} md={8} >
     <Grid item xs={12} style={{display:'flex', justifyContent:'center', alignItems:"center", }}>
      <div onClick={() => openNewWindow('https://wa.link/6nrkuc')}>
      <img  src={whatsapp} width={"250px"} height={"auto"} alt="USA_Expo" />
      </div>
     
       {/* <Typography variant="h5" style={{color: '#4D4D4D', textAlign:'center'}}>For more information, please contact +91 44 4399 6666,</Typography><br></br>
       <Typography variant="h5" style={{color: '#4D4D4D', textAlign:'center'}}>care@nacjewellers.com | Whatsapp +91 95974 57555 | Our Stores</Typography> */}

     </Grid>
    
  </Grid>
  </div>
  </>
      
    ) : (
      <h2></h2>
    )}        
      
    </>
  );
};

export default TitleAndData;